import { render, staticRenderFns } from "./ValidationMixin.vue?vue&type=template&id=2ded7833&"
import script from "./ValidationMixin.vue?vue&type=script&lang=js&"
export * from "./ValidationMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports